<h2 class="text-xl font-semibold mb-2 pr-3 pl-3 pt-2 mb-2">{{ '#DELIVERY_NOTE.DIALOGS.ADD_ITEM.TITLE' | translate }}</h2>

<div class="flex flex-row flex-nowrap center-v mt-3 mb-3 pl-3 pr-3 border-box">
  <soft-input [placeholder]="'#DELIVERY_NOTE.DIALOGS.ADD_ITEM.SEARCH_PLACEHOLDER' | translate" (valueChange)="searchChanged(input.value() ?? '')" #input></soft-input>
</div>

<div class="flex flex-col flex-nowrap border-box pl-3 pr-3 overflow-auto"
  [class.shrink]="selectedItem$ | async" #container
  [ngStyle]="{ minHeight: (selectedItem$ | async) ? 'calc(' + (initialContainerHeight) + 'px - 4rem)' : initialContainerHeight + 'px' }">
  @for (item of itemsWithInfo$ | async; track item; let last = $last) {
    <div class="flex flex-row items-center flex-nowrap border-box justify-between pt-3 pb-3 pl-3 pr-3 separator-top"
      (click)="selectOrUnselectItem(item)"
      [class.isSelected]="item?.info?.selected"
      [class.separator-bottom]="last">
      <div class="flex flex-col flex-nowrap">
        <span class="text-sm color-light">{{ item?.emballage }}</span>
        <strong>{{ item?.bezeichnung }}</strong>
      </div>
      <div class="flex items-end justify-center">
        @if (item?.info?.added && (item?.info?.quantity ?? 0) > 0) {
          <span class="soft-chip">{{ item?.info?.quantity }}</span>
        }
        <i class="fa-regular fa-star text-accent-400" [class.invisible]="!item?.favorit"></i>
      </div>
    </div>
  }
</div>

@if (selectedItem$ | async; as selectedItem) {
  <div class="flex flex-col flex-nowrap pt-3 box-border shadow-top selected-area sm:ml-3 sm:mr-3">
    <form [formGroup]="form" class="flex flex-row justify-between items-center flex-nowrap box-border pl-3 pr-3">
      <div class="flex flex-col flex-nowrap truncate">
        <span class="text-sm color-light">{{ selectedItem?.emballage }}</span>
        <strong class="truncate">{{ selectedItem?.bezeichnung }}</strong>
      </div>
      <div class="flex flex-row justify-end items-center flex-nowrap">
        <soft-number-input style="max-width: 10rem; min-width: 2.5rem;" #quantityInput
          [changeTrigger]="'input'"
          [placeholder]="'#DELIVERY_NOTE.DIALOGS.ADD_ITEM.QTY_PLACEHOLDER' | translate"
        [formControlName]="'selectedQuantityControl'"></soft-number-input>
        <span class="soft-title ml-3" style="min-width: 2rem">EH</span>
      </div>
    </form>
  </div>
}

<div class="flex flex-row border-box flex-nowrap size-aware-padding">
  <button class="soft-button secondary custom-size" (click)="close(null)">
    {{ '#DELIVERY_NOTE.DIALOGS.ADD_ITEM.CANCEL' | translate }}
  </button>
  <button class="soft-button primary custom-size" [disabled]="!(selectedItem$ | async) || !(isFormQuantityValid$ | async)" (click)="selectAndClose()">
    {{ '#DELIVERY_NOTE.DIALOGS.ADD_ITEM.SUBMIT' | translate }}
  </button>
</div>

